import React from "react";
import { Row, Card } from "react-bootstrap";
import { useHistory, withRouter } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { makingValidName } from "../../Constants/Functions";

import "./ShoeCard.scss";

const ShoeCard = ({
  id,
  img,
  name,
  oldprice,
  newprice,
  date,
  filter,
  tag,
  showCount,
  fulldata,
}) => {
  const history = useHistory();
  const newname = makingValidName(`${fulldata.name}`);
  const newskunumb = makingValidName(`${fulldata.sku_number}`);
  const newshoeid = makingValidName(`${fulldata.shoe_id}`);

  return (
    <div className={filter ? "px-container  " : "px-container large"}>
      <div className="d-flex flex-row justify-content-between card-btn-container">
        <div style={{ paddingLeft: "15px", paddingTop: "3px" }}>
          {date !== null && date !== undefined ? (
            <span className="dtTxt">{date.split("-")[0]}</span>
          ) : (
            <span>
              <br />
            </span>
          )}
        </div>
        {tag.indexOf("New") > -1 && (
          <div style={{ paddingRight: "10px", paddingTop: "5px" }}>
            <div className="btn btn-primary btnWnt">New</div>
          </div>
        )}
      </div>
      <div style={{ width: "fit-content" }}>
        <Card
          onClick={() => {
            history.push(`/${newname}_id_${newshoeid}`);
          }}
        >
          <Card.Img variant="top" src={img} loading="lazy" />
          <Card.Body>
            <Card.Title>{name}</Card.Title>
            <Card.Text>
              {newprice ? (
                <span className="newTxt"> AED {newprice}</span>
              ) : null}
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default ShoeCard;
